export enum PageRoute {
  HOME = '/',
  LOGIN = '/login',
  ACTIVATE = '/verification/activate-code',
  LOGIN_SSO_CALLBACK = '/auth/sso-callback',
  TEST = '/test',
  NOT_FOUND = '*',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
  CHANGE_PASSWORD = '/change-password',
  ACCOUNT = '/account',
  CONFIG_BILLING = '/config-billing',
  PROCESSING_LIST = '/document-processing-list',
  REQUEST = '/create-request',
  PROCESSING_REVIEW = '/document-processing-list/review',
  USAGE = '/usage',
  USAGE_DETAIl = '/usage/detail',
  INVOICE = '/invoice',
  INVOICE_DETAIL = '/invoice/detail',
  DOCUMENT_TEMPLATE = '/document-template',
  DOCUMENT_TEMPLATE_ADD = '/document-template/add',
  DOCUMENT_TEMPLATE_EDIT = '/document-template/edit',
  DOCUMENT_TEMPLATE_DETAIL = '/document-template/detail',
  DEPARTMENTS = '/departments',
  DEPARTMENTS_ADD = '/departments/add',
  DEPARTMENTS_EDIT = '/departments/edit',
  DEPARTMENTS_DETAIL = '/departments/detail',
  DEPARTMENTS_USAGE_DETAIL = '/departments/usage-detail',
  USERS = '/users',
  USER_ADD = '/users/add',
  USER_EDIT = '/users/edit',
  USER_DETAIL = '/users/detail',
  SERVICE_HISTORY = '/service-history',
  SUPPORT = '/support',
  REQUEST_WORKFLOW = '/request-workflow',
  WORKFLOW = '/workFlow',
  PREVIEW_WORKFLOW = '/request-workflow/preview',
  METADATA = '/metadata',
  WORK_FLOWS_DETAIL = '/workFlow/detail',
  METADATA_DETAIL = '/metadata/detail',
  LOGGING = '/logging',
  MBAL = '/mbal',
  MBAL_DOCSET_MAP = '/mbal/docset-map',
  MBAL_TEMPLATE_MAP = '/mbal/template-map',
}

export const ELEMENT_KEY_COMPONENT = {
  base: 'Base',
  activate: 'Auth/activate',
  authLogin: 'Auth/login',
  authForgotPass: 'Auth/forgot-pass',
  authResetPass: 'Auth/reset-pass',
  authSSOCallback: 'Auth/sso/callback',
  home: 'Home',
  account: 'Account',
  request: 'Request',
  processingList: 'Processing',
  processingReview: 'Processing/components/review',
  templateList: 'TemplateList',
  templateAddOrEdit: 'TemplateList/components/add',
  templateDetail: 'TemplateList/components/detail',
  usage: 'Billing/Usage',
  usageDetail: 'Billing/Usage/components/usageDetail',
  invoice: 'Billing/Invoice',
  invoiceDetail: 'Billing/Invoice/components/detail',
  departments: 'Manager/Departments',
  departmentAddOrEdit: 'Manager/Departments/components/add',
  departmentDetail: 'Manager/Departments/components/detail',
  departmentUsageDetail: 'Manager/Departments/components/usageDetail',
  users: 'Manager/Users',
  userAddOrEdit: 'Manager/Users/components/add',
  userDetail: 'Manager/Users/components/detail',
  billingSetting: 'Configuration/Billing',
  documentTemplate: 'DocumentTemplate',
  documentTemplateAddOrEdit: 'DocumentTemplate/components/add',
  documentTemplateDetail: 'DocumentTemplate/components/detail',
  support: 'Support',
  serviceHistory: 'ServiceHistory',
  requestWorkflow: 'WorkFlow/ListRequest',
  workFlows: 'WorkFlow/ListFlow',
  previewWorkflow: 'WorkFlow/ListRequest/component/review',
  metadata: 'Metadata',
  workFlowDetail: 'WorkFlow/ListFlow/components/detail',
  metadataDetail: 'Metadata/components/detail',
  logging: 'Logging',
  docsetMap: 'MBAL/DocsetMap',
  templateMap: 'MBAL/TemplateMap',
};

export const ROUTE_SLUG = {
  add: 'add',
  edit: 'edit',
  detail: 'detail',
};
